module.exports = __webpack_public_path__ + "img/error-dark.8440cfa2.svg";